import { PreloaderScreen } from './preloaderScreen';
import { onReadyCalcBack } from '../../general/calcIndexBackAndPopup';
import { DownloadManager } from '../../utils/downloadManager';
import { UserStatEntryType } from '../../stat/UserStatEntryType';
import { Stat } from '../../stat/Stat';
import { Localization } from '../../localization/localization';

export class NewGameVideoPreloader {
    private static videoElement: HTMLVideoElement;
    private static videoStartedAtTs: number;
    private static isFinished: boolean = false;
    private static isSkipped: boolean = false;
    private static isStarted: boolean = false;
    private static onClose: Function;

    public static async showVideoPreloader(onClose: Function) {
        this.onClose = onClose;

        if (NewGameVideoPreloader.isVideoLoadingSupported()) {
            const preloaderScreen = PreloaderScreen.getInstance();
            preloaderScreen.showPreloader();
            preloaderScreen.show();

            await NewGameVideoPreloader.loadPreloaderVideo(function handleVideoLoadingProgress(percents: number) {
                preloaderScreen.setLoadingProgress(percents);

                if (percents >= 100) {
                    preloaderScreen.hide();
                    onReadyCalcBack();
                }
            });
            NewGameVideoPreloader.isStarted = true;
            const videoContainer = $('.game-loading-video');
            const video = NewGameVideoPreloader.getVideoElement();
            videoContainer.show();

            videoContainer.on('click', () => {
                video.play();
            });

            this.setupControls();

            $(video).on('ended', () => {
                NewGameVideoPreloader.finishVideo();
            });
        }
    }

    public static getIsVideoInProgress() {
        return NewGameVideoPreloader.isStarted &&
            !(NewGameVideoPreloader.isFinished || NewGameVideoPreloader.isSkipped);
    }

    public static forceClose() {
        this.closePreloader();
    }

    private static isVideoLoadingSupported() {
        return true;
    }

    private static async loadPreloaderVideo(onProgress = (_progress: number) => {}) {
        const video = NewGameVideoPreloader.getVideoElement();
        video.src = await DownloadManager.download(video.currentSrc, {
            onProgress
        });
        video.play();
        NewGameVideoPreloader.videoStartedAtTs = Date.now();
    }

    private static hideVideoPreloader() {
        const videoContainer = $('.game-loading-video');
        videoContainer.hide();
    }

    private static getVideoElement(): HTMLVideoElement {
        if (!NewGameVideoPreloader.videoElement) {
            NewGameVideoPreloader.videoElement = $<HTMLVideoElement>('.game-loading-video video')[0];
        }
        return NewGameVideoPreloader.videoElement;
    }

    private static muteVideo() {
        const videoObject = NewGameVideoPreloader.getVideoElement();
        videoObject.muted = true;
    }

    private static toggleVideoMute() {
        const videoObject = NewGameVideoPreloader.getVideoElement();
        videoObject.muted = !videoObject.muted;
        const unmuteButton = $('.game-loading-video__unmute');
        unmuteButton.toggleClass('game-loading-video__muted');
        const text = videoObject.muted
            ? Localization._n('preloader_video.unmute')
            : Localization._n('preloader_video.mute');
        $('span', unmuteButton).text(text);
    }

    private static skipVideo() {
        NewGameVideoPreloader.getVideoElement().pause();
        NewGameVideoPreloader.isSkipped = true;
        NewGameVideoPreloader.sendWatchStatistics();
        this.closePreloader();
    }

    private static finishVideo() {
        NewGameVideoPreloader.isFinished = true;
        NewGameVideoPreloader.sendWatchStatistics();
        this.closePreloader();
    }

    private static closePreloader() {
        NewGameVideoPreloader.hideVideoPreloader();
        NewGameVideoPreloader.muteVideo();
        if (this.onClose) {
            this.onClose();
        }
    }

    private static setupControls() {
        const unmuteButton = $('.game-loading-video__unmute');

        unmuteButton.on('click', () => {
            this.toggleVideoMute();
        });

        unmuteButton.one('click', () => {
            Stat.sendEvent(UserStatEntryType.client_preloader_video_unmuted);
        });

        const skipButton = $('.game-loading-video__skip');
        skipButton.on('click', (event) => {
            event.stopPropagation();
            NewGameVideoPreloader.skipVideo();
        });
    }

    private static sendWatchStatistics() {
        const watchingDuration = Date.now() - NewGameVideoPreloader.videoStartedAtTs;
        const isFinished = NewGameVideoPreloader.isFinished ? 1 : 0;
        Stat.sendEvent(UserStatEntryType.client_preloader_video_closed, 0, [watchingDuration, isFinished]);
    }
}
